import {TextFieldHelper, TimeStringHelper} from "@goodgamestudios/core";
import {BoosterVO} from "../../../gamevo/BoosterVO";
import {ItemsVO} from "../../../gamevo/ItemsVO";
import {Poker2Model} from "../../../model/Poker2Model";
import {Poker2TextFieldHelper} from "../../helper/Poker2TextFieldHelper";
import {AvatarHelper} from "../../helper/AvatarHelper";
import {Poker2LayoutManager} from "../../Poker2LayoutManager";
import MovieClip = createjs.MovieClip;
import Container = createjs.Container;
import GlowFilter = createjs.GlowFilter;
import Rectangle = createjs.Rectangle;

export class Poker2BoosterComponent {
    private boosterBuyDialog: MovieClip;
    private itemGlow: GlowFilter;
    private ITEMS_PER_PAGE: number = 4;

    constructor(boosterBuyDialog: MovieClip) {
        this.boosterBuyDialog = boosterBuyDialog;
        this.itemGlow = new GlowFilter(0x000000, 0.35, 7, 7, 1);
    }

    public applyProperties(): void {
        this.boosterBuyDialog.mouseEnabled = true;
        this.boosterBuyDialog.mouseChildren = true;

        this.boosterBuyDialog.txt_activetitle.text = Poker2Model.languageData.getTextById("dialog_booster_titleown");
        this.boosterBuyDialog.txt_buytitle.text = Poker2Model.languageData.getTextById("dialog_booster_titlebuy");
        this.boosterBuyDialog.mc_info.visible = false;

        // info bubble
        Poker2TextFieldHelper.changeTextFromatSizeByMaxHeight(84, this.boosterBuyDialog.mc_info.txt_copy, Poker2Model.languageData.getTextById("dialog_booster_help"));
    }

    public fillOwnBooster(): void {
        while (this.boosterBuyDialog.mc_chips_holder.numChildren > 0)
            this.boosterBuyDialog.mc_chips_holder.removeChildAt(0);

        while (this.boosterBuyDialog.mc_xp_holder.numChildren > 0)
            this.boosterBuyDialog.mc_xp_holder.removeChildAt(0);

        var xpText: string = Poker2Model.languageData.getTextById("userprofil_booster_non");
        var chipsText: string = Poker2Model.languageData.getTextById("userprofil_booster_non");
        var booster: BoosterVO[] = Poker2Model.inventoryData.boosterItems;

        for (var i: number = 0; i < booster.length; i++) {
            var boosterVO: BoosterVO = booster[i];
            var time: string = TimeStringHelper.getTimeToString((boosterVO.timeleft * 1000 - Poker2Model.sessionData.getTimeSinceGameStart()) / 1000, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

            var itemBoosterMC: Container = AvatarHelper.drawItem(boosterVO);
            itemBoosterMC.scaleX = itemBoosterMC.scaleY /= Poker2LayoutManager.GAME_SCALE_FACTOR;
            if (boosterVO.boostXP > 0) {
                this.boosterBuyDialog.mc_xp_holder.addChild(itemBoosterMC);
                xpText = time;
            }
            else {
                this.boosterBuyDialog.mc_chips_holder.addChild(itemBoosterMC);
                chipsText = time;
            }
        }
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.boosterBuyDialog.txt_xp_time, xpText, 2);
        TextFieldHelper.changeTextFromatSizeByTextWidth(9, this.boosterBuyDialog.txt_chips_time, chipsText, 2);
    }

    public fillItems(): void {
        var filteredArray: any[] = Poker2Model.itemShop.shopBoosterChipsXP;

        for (var i: number = 0; i < this.ITEMS_PER_PAGE; i++) {
            var cItem: Library.PokerInterface.PokerShopItem = this.boosterBuyDialog["booster" + i] as Library.PokerInterface.PokerShopItem;
            cItem.btn_buy.toolTipText = Poker2Model.languageData.getTextById("shop_tooltip_buy_btn");

            if (i < filteredArray.length)
                this.createShopItem(filteredArray[i], cItem);
            cItem.mouseChildren = true;
        }
    }

    public createShopItem(itemVO: ItemsVO, itemHolder: Library.PokerInterface.PokerShopItem): void {
        while (itemHolder.mc_content.mc_itemholder.numChildren > 0)
            itemHolder.mc_content.mc_itemholder.removeChildAt(0);

        itemHolder.btn_buy.boosterId = itemVO.id;
        itemHolder.mc_blocked.visible = false;
        itemHolder.mc_blocked.gotoAndStop(1);
        itemHolder.mc_blocked.txt_copy.text = "";
        itemHolder.mc_chips.visible = false;
        itemHolder.txt_cash.text = "";
        itemHolder.txt_gold.text = itemVO.priceGold.toString();
        itemHolder.txt_gold.mouseEnabled = false;
        itemHolder.txt_cash.mouseEnabled = false;
        itemHolder.mc_chips.mouseEnabled = false;
        itemHolder.mc_gold.mouseEnabled = false;
        itemHolder.mc_blocked.txt_copy.mouseEnabled = false;

        if (!Poker2Model.inventoryData.hasHigherBooster(itemVO.id)) {
            this.setBoosterTooltip(itemVO, itemHolder);
        }
        else {
            itemHolder.mc_blocked.visible = true;
            itemHolder.mc_content.toolTipText = Poker2Model.languageData.getTextById("shop_tooltip_booster_inactive");
        }

        if (itemVO.level > Poker2Model.userData.userLevel) {
            itemHolder.mc_blocked.txt_copy.text = Poker2Model.languageData.getTextById("shop_minlevel", [itemVO.level]);
            itemHolder.mc_blocked.visible = true;
        }
        itemHolder.btn_buy.visible = itemHolder.mc_gold.visible = !itemHolder.mc_blocked.visible;

        itemHolder.mc_content.mouseEnabled = true;
        itemHolder.mc_content.mouseChildren = itemHolder.mc_blocked.mouseChildren = itemHolder.mc_blocked.mouseEnabled = false;

        var itemMC: Container = AvatarHelper.drawItem(itemVO);
        itemMC.filters = [this.itemGlow];
        this.itemScaleHelper(itemMC);
        itemHolder.mc_content.mc_itemholder.addChild(itemMC);
    }

    private setBoosterTooltip(itemVO: ItemsVO, item: Library.PokerInterface.PokerShopItem): void {
        if (Poker2Model.inventoryData.hasBoosterByWodId(itemVO.id)) {
            var boosterVO: BoosterVO = Poker2Model.inventoryData.getInventoryItemById(itemVO.id) as BoosterVO;
            var time: string = TimeStringHelper.getTimeToString((boosterVO.timeleft * 1000 - Poker2Model.sessionData.getTimeSinceGameStart()) / 1000, TimeStringHelper.TWO_TIME_FORMAT, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
            item.mc_content.toolTipText = Poker2Model.languageData.getTextById("userprofil_booster_runtime", [time]);
        }
        else
            item.mc_content.toolTipText = ((itemVO as BoosterVO).boostXP > 0) ? Poker2Model.languageData.getTextById("shop_tooltip_xpbooster_active") : Poker2Model.languageData.getTextById("shop_tooltip_chipsbooster_active");
    }

    private itemScaleHelper(itemMC: Container): void {
        var bounds: Rectangle = itemMC.getBounds(null);
        var scaleFactor: number = (70 / bounds.width);

        if ((bounds.height * scaleFactor) > 70)
            scaleFactor = (70 / bounds.height);
        itemMC.scaleX = itemMC.scaleY = scaleFactor;
        itemMC.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
        itemMC.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));
    }
}
